import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=a709c686&lang=scss&scoped=true"
script.__scopeId = "data-v-a709c686"

export default script